module.exports = __webpack_public_path__ + "static/media/20210410_202524_185_IMG_0348.aace538d.jpg";